var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleConfiguratorBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#0055A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9468 71.4569V93.4616H62.1761V84.5222C62.1761 77.6457 73.1485 70.7693 80.6921 70.7693V77.8672L93.2538 66.6434L80.6921 55.4196V63.2052C73.1485 63.2052 65.1478 68.2479 62.1761 71.4569V39.1376H69.2516L58.0614 25.3846L46.8713 39.1376H54.6326V61.1422C51.8895 55.0909 40.6884 51.286 35.4308 50.8275V42.3543L22.8691 54.2658L35.4308 66.1772V58.3916C45.0317 59.7669 51.8895 67.331 53.9468 71.4569Z",
    stroke: "white",
    strokeWidth: 2.30769,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleConfiguratorBlue);
export default __webpack_public_path__ + "static/media/circle-configurator-blue.ef93f1fc05c3552276ee99490dd53bf6.svg";
export { ForwardRef as ReactComponent };